import { format } from 'date-fns'

import { NOT_SET, TrackingParameter } from '@sunrise/tracking'

import { TealiumTrackingIds } from '../../ts/tracking/tealiumTrackingIds.enum'

import { MailAgentTrackingVariant } from './MsMailAgentModal.enum'

export function buildTealiumDataView(trackingVariant: MailAgentTrackingVariant): TrackingParameter {
    return {
        ...staticTealiumDataView(),
        mslayer_element_text: 'Mail_Alert_View',
        mslayer_element_variant: trackingVariant,
    }
}

function staticTealiumDataView(): TrackingParameter {
    return {
        mslayer_element_body_type: 'overlay',
        mslayer_element_company_name: NOT_SET,
        mslayer_element_count: NOT_SET,
        mslayer_element_data_id: TealiumTrackingIds.MAIL_AGENT_MODAL,
        mslayer_element_detail_start_date: getYearAndWeek(),
        mslayer_element_position: NOT_SET,
        mslayer_element_id: NOT_SET,
        mslayer_element_type_text: 'Immo_Mail_Alert_anmelden',
    }
}

export function buildStaticTealiumDataSendForm(trackingVariant: MailAgentTrackingVariant): TrackingParameter {
    return {
        ...staticTealiumDataView(),
        mslayer_element_text: 'Mail_Alert_Click',
        mslayer_element_variant: trackingVariant,
    }
}

export function getYearAndWeek() {
    return format(new Date(), 'yyyyII')
}
